import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { toast } from "react-toastify";
import "../styles/CentersSettings.css";

const CentersSettings = () => {
    const [centers, setCenters] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadCenters = async () => {
        try {
            setLoading(true);
            const res = await api.get("/api/centers/my-centers");
            setCenters(Array.isArray(res.data?.centers) ? res.data.centers : []);
        } catch (err) {
            console.error("Failed to load centers:", err);
            toast.error("Failed to load centers");
        } finally {
            setLoading(false);
        }
    };

    const handleDeactivate = async (centerId) => {
        const confirmed = window.confirm(
            "Deactivate this center? It will be hidden from the switcher, but its records will remain saved."
        );

        if (!confirmed) return;

        try {
            await api.patch(`/api/centers/${centerId}/deactivate`);

            loadCenters();
        } catch (err) {
            console.error("Deactivate center error:", err);
            toast.error(err.response?.data?.error || "Failed to deactivate center");
        }
    };

    useEffect(() => {
        loadCenters();
    }, []);

    return (
        <div className="centers-settings-page">
            <div className="centers-settings-header">
                <div>
                    <h1>Centers</h1>
                    <p>Manage organization center locations and availability.</p>
                </div>
            </div>

            <div className="centers-settings-card">
                {loading ? (
                    <p>Loading centers...</p>
                ) : centers.length === 0 ? (
                    <p>No active centers found.</p>
                ) : (
                    <table className="centers-table">
                        <thead>
                            <tr>
                                <th>Center Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {centers.map((center) => (
                                <tr key={center._id}>
                                    <td>{center.centerName}</td>
                                    <td>
                                        <span className="center-status active">Active</span>
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="danger-btn"
                                            onClick={() => handleDeactivate(center._id)}
                                        >
                                            Deactivate Center
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default CentersSettings;